import cFormLine from '#themes/default/default/components/formLine/formLine.js';
import cSelect from '#themes/default/default/components/select/select.js';

import template from './installments.html';

export default {
	name: 'CInstallments',
	components: {
		cFormLine,
		cSelect
	},
	props: {
		form: {
			type: Object,
			default: () => {}
		},
		order: {
			type: Object,
			default: () => {}
		},
		theme: {
			type: Object,
			default: () => {}
		},
		url: {
			type: Object,
			default: () => null
		}
	},
	computed: {
		installments() {
			return (this.order.price.installments || []).map(([numberOfInstallments, price]) => ({
				value: numberOfInstallments,
				label: this.t('cart_installmentsAmount', {
					numberOfInstallments,
					price: price.formatted
				})
			}));
		}
	},
	methods: {
		storeInstallments({ value: selectedInstallments } = {}) {
			this.$store.commit('SET_FORM', {
				installments: Number(selectedInstallments)
			});
		}
	},
	template
};
